import React from 'react'

import { useConditionReportCountQuery, CardType } from '@edge/spark/io-dashboards'
import { CircularProgressWidget } from '../../BaseComponents/CircularProgressWidget'
import type { BasicWidgetProps } from '../../types'

const SEARCH_STRING = 'status:available'

const ConsignedVehicles: React.FC<BasicWidgetProps> = ({
    config: { text = 'Need a CR' },
    widgetId,
    handleConfig,
    readonly,
}: BasicWidgetProps) => {
    const { data, loading } = useConditionReportCountQuery({
        variables: {
            searchString: SEARCH_STRING,
            searchStringCRs: `${SEARCH_STRING} cr:no`,
        },
    })

    const units = data?.auction?.consigned?.vehicleCount || 0
    const missingCRs = data?.auction?.cr?.vehicleCount || 0

    return (
        <CircularProgressWidget
            cardType={CardType.VEHICLE}
            action={{
                text: 'View Vehicles',
                link: `/conditionreport`,
            }}
            loading={loading}
            count={missingCRs}
            total={units}
            text={text}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default ConsignedVehicles
